// 1、是否正确联系方式
export function validatePhone(rule, value, callback) {
    const reg = /^((0\d{2,3}(-)?\d{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/
    if (value === '' || value === undefined || value == null) {
        callback()
    } else {
        if (!reg.test(value) && value !== '') {
            callback(new Error('请输入正确的电话号码'))
        } else {
            callback()
        }
    }
}
// 1、是否正确联系方式
export function validatePhoneRequired(rule, value, callback) {
    const reg = /^((0\d{2,3}(-)?\d{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/
    if (value && !reg.test(value)) {
        callback(new Error('请输入正确的电话号码'))
    } else {
        callback()
    }
}
// 2、是否邮箱
export function validateEMail(rule, value, callback) {
    const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
    if (value === '' || value === undefined || value == null) {
        callback()
    } else {
        if (!reg.test(value)) {
            callback(new Error('请输入正确的邮箱'))
        } else {
            callback()
        }
    }
}

// 3.是否是url
export function validateUrl(rule, value, callback) {
    const reg = /(http|https):\/\/([\w.]+\/?)\S*/
    if (value === '' || value === undefined || value == null) {
        callback()
    } else {
        if (!reg.test(value)) {
            callback(new Error('请输入正确的URL'))
        } else {
            callback()
        }
    }
}

// 4.账号数字或字母
export function validateAccount(rule, value, callback) {
    const reg = /^[^[\u4e00-\u9fa5]{5,16}]*$/
    if (value === '') {
        callback(new Error('请输入的账号'))
    } else if (!reg.test(value)) {
        callback(new Error('请输入正确的账号 5-16 非中文'))
    } else {
        callback()
    }
}

/**
 * 编码
 */
export function validatorCode(rule, val, callback) {
    if (!val) {
        return callback(new Error('请输入编码'))
    }
    if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,30}$/.test(val)) {
        return callback(new Error('请输入正确的编码格式：4-30位数组字母组合'))
    }
    return callback()
}

// 4.密码数字或字母
export function validatePassword(rule, value, callback) {
    const reg = /^[^[\u4e00-\u9fa5]{5,16}]*$/
    if (value === '') {
        callback(new Error('请输入的密码'))
    } else if (!reg.test(value)) {
        callback(new Error('请输入正确的密码 5-16 非中文'))
    } else {
        callback()
    }
}

//  是否合法IP地址
export function validateIP(rule, value, callback) {
    if (value) {
        const reg =
            /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
        if (!reg.test(value)) {
            callback(new Error('请输合法的IP地址'))
        } else {
            callback()
        }
    } else {
        callback()
    }
}
export function validateRequiredIP(rule, value, callback) {
    const reg =
        /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/

    if (value === '') {
        callback(new Error('请输入的IP'))
    } else if (!reg.test(value)) {
        callback(new Error('请输合法的IP地址'))
    } else {
        callback()
    }
}

// 验证端口是否在[0,65535]之间
export function validatePort(rule, value, callback) {
    const reg = /^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/
    if (!reg.test(value)) {
        callback(new Error('请输入合法的端口号'))
    } else {
        callback()
    }
}

// 验证MAC码
export function validateMac(rule, value, callback) {
    const reg = /^([0-9a-fA-F]{2}(:|-)){5}[0-9a-fA-F]{2}$/
    if (value === '') {
        callback(new Error('请输入的MAC地址'))
    } else if (!reg.test(value)) {
        callback(new Error('请输入正确的MAC地址'))
    } else {
        callback()
    }
}

// 经度必填
export function validateLng(rule, value, callback) {
    const reg = /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/ //eslint-disable-line
    if (value === '') {
        callback(new Error('请输入经度'))
    } else if (!reg.test(value)) {
        callback(new Error('请输入正确的经度'))
    } else {
        callback()
    }
}

// 纬度必填
export function validateLat(rule, value, callback) {
    const reg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/ //eslint-disable-line
    if (value === '') {
        callback(new Error('请输入纬度'))
    } else if (!reg.test(value)) {
        callback(new Error('请输入正确的纬度'))
    } else {
        callback()
    }
}

export function validateHex(rule, value, callback) {
    if (value) {
        const reg = /^([0-9a-fA-F]{2}\s)+$/
        if (!reg.test(value + ' ')) {
            callback(new Error('请输入合法的16进制命令数据 例如:22 AD 57 EF 95 DF'))
        } else {
            callback()
        }
    } else {
        callback()
    }
}
